import { api } from "../../api/api";
import {
  GET_USER_REQUEST,
  GET_USER_FAILED,
  GET_USER_SUCCESS,
  LOGIN_FAILED,
  LOGIN_SUCCESS,
  USER_SAVE_SUCCESS,
  LOGOUT,
  USER_FLAG_OFF,
  USER_SAVE_FAILED,
  USER_DELETE_SUCCESS,
  UPDATE_USER,
  LOGIN_REQUEST,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_FAILED,
  CHANGE_PASSWORD_SUCCESS,
  REFRESH_LOGIN,
  AUTH_SESSION_RESOLVED,
  EMAIL_TRANSFORED,
  EMAIL_TRANSFORED_FAILED,
  EMAIL_TRANSFOR_REQUEST
} from "../constant";

export const login = (email, password) => {
  return async (dispatch) => {
    dispatch({ type: LOGIN_REQUEST, payload: '' });
    try {
      const user = await api.post(`/user/login`, { email, password });
      if (user.status === 200) {
        if (user.data.auth) {
          dispatch({ type: LOGIN_SUCCESS, payload: user.data });
        } else {
          dispatch({ type: LOGIN_FAILED, payload: user.data });
        }
      }
    } catch (err) {
      const reason = err?.response?.data?.reason;
      dispatch({ type: LOGIN_FAILED, payload: { reason } });
    }
  };
};
export const logout = () => {
  return async (dispatch) => {
    await api.get('/user/logout');
    dispatch({
      type: LOGOUT,
      payload: "",
    });
  };
};
export const userRegister = (obj) => {
  return async (dispatch) => {
    const user = await api.post(`/user/register`, obj);
    if (user.status === 201) {
      user.data.isRegistered
        ? dispatch({
            type: USER_SAVE_SUCCESS,
            payload: user.data.user,
          })
        : dispatch({
            type: USER_SAVE_FAILED,
            payload: "",
          })
    }
  };
};
export const userFlagOff = () => {
  return async (dispatch) => {
    dispatch({
      type: USER_FLAG_OFF,
      payload: "",
    });
  };
};
export const getUsers = (id) => {
  return async (dispatch) => {
    if (id == null || id === '') return;
    dispatch({
      type: GET_USER_REQUEST,
      payload: "",
    });
    try {
      const user = await api.get(`/user/getusers/${id}`);
      if (user.status === 200) {
        const list = Array.isArray(user.data?.users) ? user.data.users : [];
        if (Array.isArray(user.data?.users)) {
          dispatch({ type: GET_USER_SUCCESS, payload: list });
        } else {
          dispatch({ type: GET_USER_FAILED, payload: "" });
        }
      }
    } catch (err) {
      dispatch({ type: GET_USER_FAILED, payload: "" });
    }
  };
};
export const deleteUser=(id)=>{
  return async (dispatch) => {
    const user=await api.get(`/user/deleteuser/${id}`);
    if(user.status===200){
      dispatch({
        type:USER_DELETE_SUCCESS,
        payload:user.data.user._id
      })
    }
  }
}
export const updateUser=(id,obj)=>{
  return async (dispatch)=>{
    const updatedUser=await api.patch(`/user/updateuser/${id}`,obj)
    if(updatedUser.status===200){
      dispatch({
        type:UPDATE_USER,
        payload:updatedUser.data.updatedUser
      })
    }
  }
}
export const forgetPassword=(email)=>{
  return async (dispatch)=>{
    dispatch({
      type:EMAIL_TRANSFOR_REQUEST,
      payload:''
    })
    const user=await api.post(`/user/forgetpassword`,{email:email})
    if(user.status===200){
      if(user.data.validUser){
        dispatch({
          type:EMAIL_TRANSFORED,
          payload:''
        })
      }
      else{
        dispatch({
          type:EMAIL_TRANSFORED_FAILED,
          payload:''
        })
      }
    }
  }
}
export const changePassword=(obj)=>{
  return async (dispatch) => {
    dispatch({
      type:CHANGE_PASSWORD_REQUEST,
      payload:''
    })
    const response=await api.patch(`/user/changepassword/${obj.id}/${obj.token}`,{newpassword:obj.password})
     try {
      if(response.status===200){
        if(response.data.timeup===false){
          dispatch({
            type:CHANGE_PASSWORD_SUCCESS,
            payload:response.data.updatedPassword
          })
        }
      }
     } catch (error) {
      dispatch({
        type:CHANGE_PASSWORD_FAILED,
        payload:''
      })
     }
  }
}
export const refreshLogin = (status, data) => {
  return async (dispatch) => {
    if (status === 200 && data?.auth) {
      dispatch({ type: REFRESH_LOGIN, payload: data });
    } else {
      dispatch({ type: AUTH_SESSION_RESOLVED, payload: { auth: false, user: {} } });
    }
  };
};

// opts: { mode: 'onboard'|'link'|'none', storeId, linkAs } — 승인과 함께 매장 처리 (12.01-D011)
export const approveUser = (id, role, opts = {}) => {
  return async (dispatch) => {
    const res = await api.patch(`/user/approve/${id}`, { ...(role != null ? { role } : {}), ...opts });
    if (res.status === 200) {
      dispatch({ type: 'USER_APPROVE_SUCCESS', payload: res.data.user });
    }
  };
};

export const rejectUser = (id) => {
  return async (dispatch) => {
    const res = await api.patch(`/user/reject/${id}`);
    if (res.status === 200) {
      dispatch({ type: 'USER_REJECT_SUCCESS', payload: res.data.user });
    }
  };
};

export const changeUserRole = (id, role, tljRegion) => {
  return async (dispatch) => {
    const res = await api.patch(`/user/changerole/${id}`, tljRegion ? { role, tljRegion } : { role });
    if (res.status === 200) {
      dispatch({ type: 'USER_ROLE_CHANGED', payload: res.data.user });
    }
  };
};

/** 어드민: 대상 유저에게 비밀번호 재설정 이메일 발송 */
export const adminSendResetEmail = (userId) => {
  return async () => {
    const res = await api.post(`/user/admin-send-reset/${userId}`);
    return res.data;
  };
};
